<template>
  <div id="game_team_list_outer" v-if="teamList != null">
    <div v-if="teamList.length > 0">
      <a class="item" href="javascript:void(null)"
         v-for="(item, index) in teamList"
         @click="teamItemClicked(index)"
         :key="'team_name' + index">
        <img :src="teamIcon">
        <div>{{item.name}}</div>
      </a>
    </div>
    <div v-else style="height: 200px;color: #333;display: flex;flex-direction: column;align-items: center;justify-content: center;">
      <span>暂无相关信息</span>
    </div>
  </div>
</template>

<script>
  import TestImg from '../../assets/shl_game_team_default.png';
  import GameHttpManager from '../../js/outer-games-http-define';
export default {
  name: "GameTeamsListPage",
  data() {
    return {
      teamList: null,
      teamIcon: TestImg
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      let _this = this;
      GameHttpManager.getTeamListData(function (data) {
        let status = data.status;
        if (status == 'success') {
          _this.teamList = data.data;
        }
      }, function () {
        _this.$toast('加载失败，请重试！');
      });
    },
    teamItemClicked(index) {
      let item = this.teamList[index];


      // let item = this.gameList[index];
      let id = item.id;
      let l = this.$router.resolve({
        name: 'matchGamesHomePage',
        params: {
          id: this.$route.params.id
        },
        query: {
          index: 3,
          sub: 1,
          id: id,
        }
      });
      // this.$router.go(0);
      window.open(l.href, '_self');
    }
  }
}
</script>

<style scoped>

  #game_team_list_outer {
    box-shadow: 0 0 15px rgba(255,0,0, 0.15);
    padding: 20px 15px;
    margin-top: 30px;
    padding-top: 5px;
  }

  #game_team_list_outer > div {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }


  #game_team_list_outer > div a {
    color: #333;
    text-decoration: none;
  }

  #game_team_list_outer > div a:hover {
    color: #fc1a34;
  }

  #game_team_list_outer > div .item {
    width: 100%;
    margin-top: 20px;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    max-width: 300px;
  }

  #game_team_list_outer > div .item img {
    width: 40px;
    height: auto;
    /*border-radius: 30px;*/
  }

  #game_team_list_outer > div .item div {
    margin-left: 15px;
  }

  @media screen and (min-width: 768px) {
    #game_team_list_outer {
      padding: 40px 30px;
      padding-top: 25px;
    }

    #game_team_list_outer > div .item {
      width: 50%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/outer-matches/GameTeamsListPage.vue